var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.957,
    height: 23.25,
    viewBox: "0 0 23.957 23.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1046.266 -5016.675)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1041.922 5020.826)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1028.725,5020.333h-4.946a.648.648,0,0,0-.461.191l-8.584,8.584a.649.649,0,0,0-.19.46.658.658,0,0,0,.19.461l4.948,4.946a.651.651,0,0,0,.46.191.657.657,0,0,0,.461-.191l8.583-8.584a.66.66,0,0,0,.191-.46v-4.947A.652.652,0,0,0-1028.725,5020.333Zm-.652,5.328-7.931,7.933-4.026-4.026,7.933-7.932h4.025Z",
    transform: "translate(1042.906 -5020.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1031.781,5025.262a1.133,1.133,0,0,0,1.132-1.133,1.132,1.132,0,0,0-1.132-1.132,1.132,1.132,0,0,0-1.132,1.132A1.133,1.133,0,0,0-1031.781,5025.262Z",
    transform: "translate(1042.906 -5020.333)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1038.7,5020.044l-3.167-3.167a.7.7,0,0,0-.512-.2.692.692,0,0,0-.512.2l-3.167,3.167a.7.7,0,0,0,0,.991.7.7,0,0,0,.5.205.7.7,0,0,0,.495-.205l1.989-1.989v7.03a.7.7,0,0,0,.7.7.7.7,0,0,0,.7-.7v-7.03l1.988,1.989a.7.7,0,0,0,.495.205.7.7,0,0,0,.5-.205A.7.7,0,0,0-1038.7,5020.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1032.855,5035.558l3.167,3.167a.694.694,0,0,0,.512.2.7.7,0,0,0,.512-.2l3.167-3.167a.7.7,0,0,0,0-.99.7.7,0,0,0-.495-.205.7.7,0,0,0-.5.205l-1.989,1.988v-7.03a.7.7,0,0,0-.7-.7.7.7,0,0,0-.7.7v7.03l-1.989-1.988a.7.7,0,0,0-.495-.205.7.7,0,0,0-.495.205A.7.7,0,0,0-1032.855,5035.558Z",
    transform: "translate(2.984 0.999)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceUpdate);
export default __webpack_public_path__ + "static/media/price-update.391ae2d81739a259ee76ab5c1dfda76a.svg";
export { ForwardRef as ReactComponent };